/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Create_RoleInputs */

const en_admin_roles_create_role = /** @type {(inputs: Admin_Roles_Create_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Role`)
};

const zh_admin_roles_create_role = /** @type {(inputs: Admin_Roles_Create_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建角色`)
};

/**
* | output |
* | --- |
* | "Create Role" |
*
* @param {Admin_Roles_Create_RoleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_create_role = /** @type {((inputs?: Admin_Roles_Create_RoleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Create_RoleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_create_role(inputs)
	return zh_admin_roles_create_role(inputs)
});
export { admin_roles_create_role as "admin.roles.create_role" }